var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{class:['my-common-modal', _vm.className],attrs:{"modal":true,"visible":_vm.myVisible,"append-to-body":true,"title":_vm.title,"before-close":_vm.handleClose,"close-on-click-modal":false,"top":"0vh","width":_vm.width},on:{"update:visible":function($event){_vm.myVisible=$event}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }